import React, { Fragment, useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'

import { parseQueryString } from '../../utils/generic'
import { Carousel } from '../../atomic-components/organisms/carousel'
import { Layout } from '../../atomic-components/organisms/layout'
import { UspsBar } from '../../atomic-components/organisms/uspsBar'
import { ContentWrapper } from '../../atomic-components/atoms/contentWrapper'
import { ProductMenuCarousel } from '../../atomic-components/organisms/productMenuCarousel'
import { LogosCarousel } from '../../atomic-components/molecules/logosCarousel'
import { ContentAreaColumn } from '../../atomic-components/molecules/contentAreaColumn'
import { ContentAreaRow } from '../../atomic-components/molecules/contentAreaRow'
import { GamesCarousel } from '../../atomic-components/molecules/gamesCarousel'
import { Seo } from '../../atomic-components/organisms/seo'
import storageService from '../../services/storageService'

import { useHomePageApiData } from '../../hooks/graphqlStaticQuery/useHomePageApiData'

import tickIcon from '../../images/black_tick.svg'
import rightArrow from '../../images/right-arrow.svg'
import { useTranslation } from '../../context/translationProvider'
import useSlugs from '../../hooks/useSlugs'
import { CAFModal } from '../../atomic-components/organisms/CAFModal'
import useQueryParams from '../../hooks/useQueryParams'
import { useLocalePathPrefix } from '../../utils/getWebsiteUrl'
import { AltenarSportsbook } from '../../atomic-components/organisms/AltenarSportsbook'

import { isFbUser } from '../../helpers/urlHelper'
import { If } from '@techmobilt/ui-components'

const locale = process.env.GATSBY_INTL_LOCALE

const IndexPage = ({ pageContext: { customHome } }) => {
  const { layoutData } = useHomePageApiData(customHome)
  const [registerSlug] = useSlugs(['register'])
  const { translate } = useTranslation()
  const [seoPathParams, setSeoPathParams] = useState({})
  const { onboarding } = useQueryParams()
  const uspsData = [
    {
      icon: tickIcon,
      title: translate('usps.earlyGain'),
    },
    {
      icon: tickIcon,
      title: translate('usps.greatOdds'),
    },
    {
      icon: tickIcon,
      title: translate('usps.InstantWithdrawal'),
    },
  ]
  // Uncomment when returning workers
  // const [layoutData, setLayoutData] = useState([
  //   { acf_fc_layout: 'banners' },
  //   { acf_fc_layout: 'logos_area' },
  //   { acf_fc_layout: 'logos_area' },
  //   { acf_fc_layout: 'games_area' },
  //   { acf_fc_layout: 'games_area' },
  //   { acf_fc_layout: 'games_area' },
  // ])

  // useEffect(() => {
  //   const getFilteredData = async () => {
  //     const layoutData = await homeWorker ?.filterData(data, customHome)
  //     setLayoutData(layoutData)
  //   }
  //   getFilteredData()
  // }, [])

  const location = useLocation()
  const params = parseQueryString(location.search)

  useEffect(() => {
    if (params.casinoMessage === 'redirect') {
      window?.parent?.postMessage({ redirect: true }, '*')
    }
  }, [params])

  const lobby = storageService.getValue('lobby')
  const redirectToLobby = storageService.getSessionValue('redirectToLobby')
  const isLoggedIn = !!storageService.getValue('user')
  if (lobby && !redirectToLobby && !customHome && !onboarding && isLoggedIn) {
    if (useLocalePathPrefix && lobby.indexOf(`/${locale}/`) >= 0) {
      navigate(lobby.replace(`/${locale}`, ''))
      storageService.setSessionValue('redirectToLobby', true)
      return null
    }
    navigate(lobby)
    storageService.setSessionValue('redirectToLobby', true)
    return
  }

  return (
    <Layout seoPathParams={seoPathParams}>
      <ContentWrapper gap="1em" gapMobile="0.75em">
        {layoutData.map((row, i) => {
          switch (row.acf_fc_layout) {
            case 'banners':
              return (
                <Fragment key={`banners-${i}`}>
                  <Carousel slides={row.banners} useGatsbyImage />
                  <UspsBar
                    usps={uspsData}
                    cta={{
                      title: 'Registrar Agora',
                      icon: `${rightArrow}`,
                      link: `/${registerSlug}/`,
                    }}
                  />
                </Fragment>
              )
            case 'products_area':
              return (
                <ProductMenuCarousel
                  key={`products_area-${i}`}
                  slides={row?.products_list}
                />
              )
            case 'logos_area':
              return <LogosCarousel key={`logos_area-${i}`} content={row} />
            case 'games_area':
              return <GamesCarousel key={`games_area-${i}`} content={row} />
            case 'content_area_1':
              return (
                <ContentAreaColumn key={`content_area_1-${i}`} content={row} />
              )
            case 'content_area_2':
              return (
                <ContentAreaRow key={`content_area_2-${i}`} content={row} />
              )
            default:
              return <div key={`layout-${i}`} />
          }
        })}
      </ContentWrapper>
      <If
        condition={isFbUser()}
        render={() => (
          <AltenarSportsbook
            eventQueryParams={''}
            contextPage={'overview'}
            setSeoPathParams={setSeoPathParams}
          />
        )}
      />

      <CAFModal />
    </Layout>
  )
}

export default IndexPage

export const Head = ({
  pageContext: { yoastHead, hrefLangs },
  location: { pathname },
}) => {
  return (
    <Seo
      yoast={{ yoast_head_json: yoastHead?.json }}
      href_langs={hrefLangs}
      pathname={pathname}
    />
  )
}
